import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealth } from '../../../../api';
import { useWealthContext } from '../../../../contexts/wealth-context';
import { useBalanceSheetTableColDefs } from '../../../../hooks/useBalanceSheetTableColDefs';
import type { IModalBalanceEntry } from '../../../../interfaces/balance-sheet-table';
import { BalanceSheetCategoryTitle } from '../BalanceSheetCategoryTitle';
import { BalanceSheetTable } from '../BalanceSheetTable';

interface IProps {
    handleShowModal: (modalEntry: IModalBalanceEntry) => void;
}

export const AssetTable: FunctionComponent<IProps> = ({ handleShowModal }) => {
    const { t } = useTranslation();
    const { clientCurrency } = useWealthContext();
    const { assets, assetsTotal } = useWealth();

    const assetsColDefs = useBalanceSheetTableColDefs('assets', clientCurrency ?? '');

    return (
        <div className="balance-sheet-table__container">
            <BalanceSheetCategoryTitle
                title={t('wealthAssetSectionTitle')}
                totalText={t('wealthAssetSectionTotal')}
                currency={clientCurrency}
                totalAmountCurrentYear={assetsTotal}
                isBankable={true}
            />
            <BalanceSheetTable balanceSheetData={assets} tableColDefs={assetsColDefs} onRowActionClick={handleShowModal} />
        </div>
    );
};
